export default {
  contact_hero_title: 'CONTACT US',

  quick_call: 'Call Us',
  quick_email: 'Email Us',
  quick_follow: 'Follow Us',
  quick_area: 'Service Area',

  panel_company: 'FMO LLC Insulation Services',
  panel_desc: 'Professional insulation solutions for residential and commercial properties in Lafayette, Indiana. Spray foam, batt, cellulose, blown-in, attic, wall, and crawl space with over 15 years of experience.',
  panel_area_title: 'Service Area',
  panel_area_main: 'Lafayette, Indiana',
  panel_area_sub: 'and Surrounding Communities',
  panel_hours_title: 'Business Hours',
  panel_hours_weekdays: 'Mon - Sat: 8:00 AM - 5:00 PM',
  panel_hours_weekends: 'Sun: Closed',
  panel_why_title: 'Why Choose FMO LLC?',
  panel_why_1: 'Free estimates with no commitment',
  panel_why_2: 'Response in less than 24 hours',
  panel_why_3: 'Guaranteed professional service',
  panel_why_4: 'Serving Lafayette and surrounding areas',
  panel_cta: 'Complete the form on the right and get your personalized quote today.',

  form_badge: 'REQUEST A FREE QUOTE',
  form_title: 'Complete the form and we will respond quickly',
  form_placeholder_name: 'Enter your name',
  form_placeholder_last: 'Enter your last name',
  form_placeholder_email: 'Enter your email address',
  form_placeholder_phone: 'Enter your phone number',
  form_placeholder_address: 'Enter your property address',
  form_placeholder_message: 'Tell us about your property and what you need...',
  form_char_count: '{{count}}/500',
  form_submit: 'Get Your Free Quote! \uD83D\uDC49',
};